import React from "react";
import clsx from "clsx";
import { mergeStyleSets } from "office-ui-fabric-react";
import { Nomination } from "../../models";

interface IProps {
  nomination: Nomination;
}

const classes = mergeStyleSets({
  container: { flex: "1 1 auto", overflowY: "auto", height: "auto" }
});

export const NominationDetailsPane: React.FC<IProps> = props => {
  let result = <></>;
  const { nomination } = props;

  switch (nomination.transferType) {
    case "Tank Transfer":
      result = (
        <table className="tbl-detail">
          <tbody>
            <tr>
              <td colSpan={2}>
                <dt>Surveyor</dt>
                <dd id="lbl-nomination-surveyor">
                  {nomination.surveyor}&nbsp;
                </dd>
              </td>
            </tr>
            <tr>
              <td>
                <dt>Direction</dt>
                <dd id="lbl-nomination-direction">
                  {nomination.nominationType}&nbsp;
                </dd>
              </td>
              <td>
                <dt>Dock</dt>
                <dd id="lbl-nomination-dock">{nomination.dock}&nbsp;</dd>
              </td>
            </tr>
            <tr>
              <td>
                <dt>Customer</dt>
                <dd id="lbl-nomination-surveyor">
                  {nomination.customer}&nbsp;
                </dd>
              </td>
              <td>
                <dt>Product</dt>
                <dd id="lbl-nomination-product">{nomination.product}&nbsp;</dd>
              </td>
            </tr>
            <tr>
              <td>
                <dt>Tank</dt>
                <dd id="lbl-nomination-tank">
                  {nomination.tank.substring(4)}&nbsp;
                </dd>
              </td>
              <td>
                <dt>Quantity</dt>
                <dd id="lbl-nomination-quantity">
                  {nomination.quantity}&nbsp;
                </dd>
              </td>
            </tr>
            <tr>
              <td>
                <dt>Jetty Line</dt>
                <dd id="lbl-nomination-jetty-line">
                  {nomination.jettyLine}&nbsp;
                </dd>
              </td>
              <td>
                <dt>Ship Line</dt>
                <dd id="lbl-nomination-ship-line">
                  {nomination.shipLine}&nbsp;
                </dd>
              </td>
            </tr>
            <tr>
              <td>
                <dt>Vapor Line</dt>
                <dd id="lbl-nomination-vapor-line">
                  {nomination.vaporLine}&nbsp;
                </dd>
              </td>
              <td>
                <dt>Ship Vapor Line</dt>
                <dd id="lbl-nomination-ship-vapor-line">
                  {clsx(
                    nomination.shipVaporLine,
                    nomination.shipVaporLineDescription &&
                      ` - ${nomination.shipVaporLineDescription}`
                  )}
                </dd>
              </td>
            </tr>
            <tr>
              <td>
                <dt>Stowage</dt>
                <dd id="lbl-nomination-stowage">{nomination.stowage}&nbsp;</dd>
              </td>
              <td>&nbsp;</td>
            </tr>
          </tbody>
        </table>
      );
      break;
    case "Direct Transfer":
      result = (
        <table className="tbl-detail">
          <tbody>
            <tr>
              <td colSpan={2}>
                <dt>Surveyor</dt>
                <dd id="lbl-nomination-surveyor">
                  {nomination.surveyor}&nbsp;
                </dd>
              </td>
            </tr>
            <tr>
              <td>
                <dt>Direction</dt>
                <dd id="lbl-nomination-direction">
                  {nomination.nominationType}&nbsp;
                </dd>
              </td>
              <td>
                <dt>Dock</dt>
                <dd id="lbl-nomination-dock">{nomination.dock}&nbsp;</dd>
              </td>
            </tr>
            <tr>
              <td>
                <dt>Customer</dt>
                <dd id="lbl-nomination-customer">
                  {nomination.customer}&nbsp;
                </dd>
              </td>
              <td>
                <dt>Product</dt>
                <dd id="lbl-nomination-product">{nomination.product}&nbsp;</dd>
              </td>
            </tr>
            <tr>
              <td>
                <dt>Tank</dt>
                <dd id="lbl-nomination-tank">
                  {nomination.tank.substring(4)}&nbsp;
                </dd>
              </td>
              <td>
                <dt>Quantity</dt>
                <dd id="lbl-nomination-quantity">
                  {nomination.quantity}&nbsp;
                </dd>
              </td>
            </tr>

            <tr>
              <td>
                <dt>Jetty Line</dt>
                <dd id="lbl-nomination-jetty-line">
                  {nomination.jettyLine}&nbsp;
                </dd>
              </td>
              <td>
                <dt>Ship Line</dt>
                <dd id="lbl-nomination-ship-line">
                  {nomination.shipLine}&nbsp;
                </dd>
              </td>
            </tr>
            <tr>
              <td>
                <dt>Vapor Line</dt>
                <dd id="lbl-nomination-vapor-line">
                  {nomination.vaporLine}&nbsp;
                </dd>
              </td>
              <td>
                <dt>Ship Vapor Line</dt>
                <dd id="lbl-nomination-ship-vapor-line">
                  {clsx(
                    nomination.shipVaporLine,
                    nomination.shipVaporLineDescription &&
                      ` - ${nomination.shipVaporLineDescription}`
                  )}
                </dd>
              </td>
            </tr>
            <tr>
              <td>
                <dt>Stowage</dt>
                <dd id="lbl-nomination-stowage">{nomination.stowage}&nbsp;</dd>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      );
      break;
    case "OTS Transfer":
      result = (
        <table className="tbl-detail">
          <tbody>
            <tr>
              <td colSpan={2}>
                <dt>Surveyor</dt>
                <dd id="lbl-nomination-surveyor">
                  {nomination.surveyor}&nbsp;
                </dd>
              </td>
            </tr>
            <tr>
              <td>
                <dt>Direction</dt>
                <dd id="lbl-nomination-direction">
                  {nomination.nominationType}&nbsp;
                </dd>
              </td>
              <td>
                <dt>Dock</dt>
                <dd id="lbl-nomination-dock">{nomination.dock}&nbsp;</dd>
              </td>
            </tr>
            <tr>
              <td>
                <dt>Customer</dt>
                <dd id="lbl-nomination-customer">
                  {nomination.customer}&nbsp;
                </dd>
              </td>
              <td>
                <dt>Product</dt>
                <dd id="lbl-nomination-product">{nomination.product}&nbsp;</dd>
              </td>
            </tr>
            <tr>
              <td>
                <dt>Vessel</dt>
                <dd id="lbl-nomination-vessel">
                  {nomination.tank.substring(4)}&nbsp;
                </dd>
              </td>
              <td>
                <dt>Quantity</dt>
                <dd id="lbl-nomination-quantity">
                  {nomination.quantity}&nbsp;
                </dd>
              </td>
            </tr>
            <tr>
              <td>
                <dt>Ship Line</dt>
                <dd id="lbl-nomination-ship-line">
                  {nomination.shipLine}&nbsp;
                </dd>
              </td>
              <td>
                <dt>Ship Vapor Line</dt>
                <dd id="lbl-nomination-ship-vapor-line">
                  {clsx(
                    nomination.shipVaporLine,
                    nomination.shipVaporLineDescription &&
                      ` - ${nomination.shipVaporLineDescription}`
                  )}
                </dd>
              </td>
            </tr>
            <tr>
              <td>
                <dt>Stowage</dt>
                <dd id="lbl-nomination-stowage">{nomination.stowage}&nbsp;</dd>
              </td>
              <td>&nbsp;</td>
            </tr>
          </tbody>
        </table>
      );
      break;
  }

  return (
    <div className={clsx(classes.container, "custom-scroll")}>
      <div>{result}</div>
    </div>
  );
};
